import { Outlet } from 'react-router';

import { ForceLogoutWatcher } from '@/app/auth/ForceLogoutWatcher';
import { SessionExpiredWatcher } from '@/app/auth/SessionExpiredWatcher';
import { RequireAuth } from '@/app/auth/RequireAuth';
import { DebugModeProvider } from '@/ui';
import { NavLayout } from '@/app/shell/NavLayout';
import { AgencyConfigurationProvider } from '@/app/shell/AgencyConfigurationProvider';
import { IncidentDataProvider } from '@/app/shell/IncidentDataProvider';

export function AppShellRoute() {
  return (
    <DebugModeProvider enableShortcut>
      <RequireAuth>
        <ForceLogoutWatcher />
        <SessionExpiredWatcher />
        <AgencyConfigurationProvider>
          <IncidentDataProvider>
            <NavLayout>
              <Outlet />
            </NavLayout>
          </IncidentDataProvider>
        </AgencyConfigurationProvider>
      </RequireAuth>
    </DebugModeProvider>
  );
}
